import Vue from 'vue';

import router from '@/router/router.js';
import store from '@/store/store';
import '@/directives';
import { i18n, vuetify } from '@/plugins';
import App from '@/App';

import { version, name } from '../package.json';

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app');

const CURRENT_VERSION = `${name.toUpperCase()} - ${version}`;

console.info(`%c${CURRENT_VERSION}`, 'color: #4f44e0;font-size:12px');
console.info(`%cApplication version: ${process.env.CI_COMMIT_REF_NAME || 'local'}`, 'color: #4f44e0;font-size:12px');
